import { MARKER_RADIUS } from '../markers/constants.js';

/**
 * Resolves Infinity/-Infinity pixel values to just beyond the chart boundary so
 * the pill's rounded cap is clipped by the SVG viewport, producing a flat edge.
 * Finite pixel values are returned unchanged.
 * @param y - pixel position (may be Infinity/-Infinity for unbounded thresholds)
 * @param plotSize - length of the plot area in pixels
 */
export function resolveInfinitePixel(y: number, plotSize: number): number {
  if (isFinite(y)) {
    return y;
  }
  const isPositive = y > 0;

  return isPositive ? plotSize + MARKER_RADIUS : -MARKER_RADIUS;
}
